export default "__VITE_ASSET__CXF7c7Pw__"